import createLucideIcon from '../createLucideIcon';

const BookDown = createLucideIcon('BookDown', [
  ['path', { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20', key: '126fyg' }],
  [
    'path',
    {
      d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z',
      key: '19jkyh',
    },
  ],
  ['path', { d: 'M12 13V7', key: 'h0r20n' }],
  ['path', { d: 'm9 10 3 3 3-3', key: 'zt5b4y' }],
]);

export default BookDown;
